// extracted by mini-css-extract-plugin
module.exports = {"root":"calendar-card_root__mZyAM"};